/** Chaves de corpo HTTP seguras para contexto de auditoria (sem PII). */
const CHAVES_CORPO_SEGURAS = [
  'status',
  'fase',
  'statusAntes',
  'statusDepois',
  'faseAnterior',
  'faseNova',
  'anoExecucao',
  'acao',
  'decisao',
] as const;

/**
 * Extrai pares chave/valor não sensíveis do corpo da requisição para o contexto de audit.
 */
export function extrairContextoAuditavel(body: unknown): Record<string, string> {
  if (!body || typeof body !== 'object' || body instanceof FormData) {
    return {};
  }

  const registro = body as Record<string, unknown>;
  const contexto: Record<string, string> = {};

  for (const chave of CHAVES_CORPO_SEGURAS) {
    const valor = registro[chave];
    if (typeof valor === 'string' && valor.length > 0 && valor.length <= 120) {
      contexto[chave] = valor;
    } else if (typeof valor === 'number' && Number.isFinite(valor)) {
      contexto[chave] = String(valor);
    }
  }

  return contexto;
}
